import { render } from "./StakingAnalytics.vue?vue&type=template&id=d9d9fb0c&scoped=true"
import script from "./StakingAnalytics.vue?vue&type=script&lang=js"
export * from "./StakingAnalytics.vue?vue&type=script&lang=js"

import "./StakingAnalytics.vue?vue&type=style&index=0&id=d9d9fb0c&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9d9fb0c"],['__file',"resources/js/components/StakingAnalytics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d9d9fb0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d9d9fb0c', __exports__)) {
    api.reload('d9d9fb0c', __exports__)
  }
  
  module.hot.accept("./StakingAnalytics.vue?vue&type=template&id=d9d9fb0c&scoped=true", () => {
    api.rerender('d9d9fb0c', render)
  })

}


export default __exports__